import React, {useState, useEffect, useRef} from 'react'
import Icon from 'components/utils/Icon'
import CircleButton from 'components/utils/CircleButton'
import Modal from 'components/utils/Modal'
import SearchBar from 'components/utils/SearchBar'
import Locate from 'components/menu/LocateJob'
//import JobMenu from 'components/menu/Job'
//import PropMenu from 'components/menu/Proposal'
import User from 'components/menu/User'
//import Rate from 'components/menu/Rate'
//import Client from 'components/menu/Client'
//import Contact from 'components/menu/Contact'
import SiteLocation from 'components/utils/SiteLocation'
//import ViewClient from 'components/input/Client'
//import ViewContact from 'components/input/Contact'

import { formatDateYMD, formatDateTime, getLocation, replaceStr, isElectron, exportToExcel, filterData, addActivity } from 'scripts/common'
import Description from 'components/menu/Description'

const Library = (props) => {

  const googleRef = useRef(null)
  const mapRef = useRef(null)
  const markerRef = useRef([])

  const [fetchedData, setFetchedData] = useState([])
  const [fetchedReadOnly, setFetchedReadOnly] = useState([])
  const [isModal, setIsModal] = useState({
    add: false,
    editMode: false,
    edit: false,
    google: false,
    locate: false,
    user: false,
    job: false,        
    site: false,    
    editAddress: false
  })

  // const [isAdd, setIsAdd] = useState({
  //   newJob: false,
  //   billingGroup: false,
  //   needJobMenu: false,
  //   propToJob: false,
  //   newProp: false,
  //   needPropMenu: false
  // })

  const [isLoading, setIsLoading] = useState(true)

  const isChanged = useRef(false)

  const [searchValue, setSearchValue] = useState('')

  const [isValidated, setIsValidated] = useState({
    entryby: '',
    entrytime: null,
    entrylat: '',
    entrylng: '',
    entrydevice: '',
    modby: '',
    modtime: null,
    modlat: '',
    modlng: '',
    moddevice: '',
    id: null,        
    description: '',
    company: '',
    jobDate: null,
    address: '',
    city: '',
    county: '',
    state: '',
    zip: '',
    latitude: '',
    longitude: '',
    elevation: '',
    siteLocation: '',
    siteArea: ''    
  })

  const clearIsValidated = () => setIsValidated({
    entryby: '',
    entrytime: null,
    entrylat: '',
    entrylng: '',
    entrydevice: '',
    modby: '',
    modtime: null,
    modlat: '',
    modlng: '',
    moddevice: '',
    id: null,        
    description: '',
    company: '',
    jobDate: null,
    address: '',
    city: '',
    county: '',
    state: '',
    zip: '',
    latitude: '',
    longitude: '',
    elevation: '',
    siteLocation: '',
    siteArea: ''
  })  

  const fetchData = () => {    

    fetch('/api/selectLibrary', {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      }
    })
    .then(res=>res.json())
    .then(
      (result) => {
        //console.log('result: ' + result)

        addActivity('jobs', props.filter.jobNumber, '', props.component, 'view', '', props.user.username)

        setFetchedData(result.map(data => (
          {...data,
            formatID: 'id' + data.id,
            entrytime: formatDateTime(data.entrytime),
            modtime: formatDateTime(data.modtime),
            jobDate: formatDateYMD(data.jobDate)
          }
        )))        

        setIsLoading(false)

      },
      (error) => {
        console.log('Error: selectLibrary --> ' + error)
      }
    )    

  }

  useEffect(() => {
    if (isModal.google) {
      //initMap()

      let data = fetchedData.filter(data => {

        if (data.latitude !== '' && data.latitude !== null && data.longitude !== '' && data.longitude !== null) {          

          return true          

        }

        return false


      })

      let google = googleRef.current

      mapRef.current = new window.google.maps.Map(google, {
           mapTypeId: window.google.maps.MapTypeId.ROADMAP
      });

      let infoWindow = new window.google.maps.InfoWindow();

      let marker, i, latLng

      //let i, latLng

      let bounds = new window.google.maps.LatLngBounds();

      //console.log(`locations: ${JSON.stringify(data)}`)

      for (i = 0; i < data.length; i++) {

        //desc = data[i].description === null ? '' : data[i].description        

        marker = new window.google.maps.Marker({
          position: new window.google.maps.LatLng(data[i].latitude, data[i].longitude),
          title: `Company: ${data[i].company}, Desc: ${data[i].description}, Date: ${data[i].jobDate}`,
          animation: window.google.maps.Animation.DROP,
          map: mapRef.current,
          icon: {
            url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
          },
          id: data[i].id,
          visible: filterData(data[i], searchValue)
        });

        marker.setMap(mapRef.current)

        markerRef.current.push(marker)

        latLng = new window.google.maps.LatLng(data[i].latitude, data[i].longitude);

        bounds.extend(latLng);

        window.google.maps.event.addListener(marker, 'click', function () {
          infoWindow.setContent('<h3>' + this.title + '</h3>');
          infoWindow.open(mapRef.current, this);
        });

      }

      mapRef.current.fitBounds(bounds);

      mapRef.current.setCenter(bounds.getCenter());

    }
  }, [props.filter, isModal.google, fetchedData])

  useEffect(() => {
    if (isModal.google) updateMap()
  }, [searchValue, isModal.google, fetchedData])

  useEffect(() => {
    fetchData()
  }, [props.filter])

  // Sets the map on all markers in the array.
  const hightlightMarker = (e) => {

    let id = parseInt(e.target.parentNode.getAttribute('data-id'))

    for (let i = 0; i < markerRef.current.length; i++) {
      if (markerRef.current[i].get("id") === id) {

        markerRef.current[i].setIcon('http://maps.google.com/mapfiles/ms/icons/yellow-dot.png')
        markerRef.current[i].setAnimation(window.google.maps.Animation.BOUNCE)
      } else {

        markerRef.current[i].setIcon('http://maps.google.com/mapfiles/ms/icons/blue-dot.png')
        markerRef.current[i].setAnimation(null)
        markerRef.current[i].getVisible(false)
      }

      markerRef.current[i].setMap(mapRef.current);
    }
  }

  const updateMap = (id, visible) => {

    for (let i = 0; i < markerRef.current.length; i++) {
      if (markerRef.current[i].get("id") === id) {

        markerRef.current[i].setVisible(visible)

      }

      markerRef.current[i].setMap(mapRef.current);
    }
  }

  const validate = (event) => {
    let name = event.target.getAttribute('name')
    let state = event.target.reportValidity()
    let type = event.target.type
    let value = type === 'checkbox' ? event.target.checked : event.target.value

    setIsValidated(prevState => ({...prevState, [name]: state ? value : null}))
  }

  const changedData = () => isChanged.current = true

  const selectRow = (e) => {

    let target = e.target
    //console.log(`target: ${target.nodeName}`)
    let tr = target.nodeName === 'I' ? target.parentNode.parentNode.parentNode : target.nodeName === 'Button' ? target.parentNode.parentNode : target.parentNode
    let td = tr.getElementsByTagName('td')
    let i = tr.getAttribute('data-i') //td[4].textContent // usually 0, but listOfData was reorganized

    if (i === '' || i === null) {
      alert('Error: data index not found. Contact an admin.')
    } else {

      if (target.nodeName === 'TD') {

        //console.log(`i: ${i}`)

        //console.log(`derp: ${JSON.stringify(fetchedData)}`)

        setIsValidated(prevState => ({...prevState,
          entryby: fetchedData[i].entryby,
          entrytime: fetchedData[i].entrytime,
          entrylat: fetchedData[i].entrylat,
          entrylng: fetchedData[i].entrylng,
          entrydevice: fetchedData[i].entrydevice,
          modby: fetchedData[i].modby,
          modtime: fetchedData[i].modtime,
          modlat: fetchedData[i].modlat,
          modlng: fetchedData[i].modlng,
          moddevice: fetchedData[i].moddevice,
          id: fetchedData[i].id,          
          description: fetchedData[i].description,
          company: fetchedData[i].company,
          jobDate: fetchedData[i].jobDate,
          address: fetchedData[i].address,
          city: fetchedData[i].city,
          county: fetchedData[i].county,
          state: fetchedData[i].state,
          zip: fetchedData[i].zip,
          latitude: fetchedData[i].latitude,
          longitude: fetchedData[i].longitude,
          elevation: fetchedData[i].elevation,
          siteLocation: fetchedData[i].siteLocation,
          siteArea: fetchedData[i].siteArea,
          filePath: fetchedData[i].filePath          
        }))
        openEdit()

      }

    }

  }

  const selectLocate = (data) => {

    //console.log(`siteInfo: ${JSON.stringify(data)}`)

    setIsValidated(prevState => ({...prevState,
      latitude: data.latitude,
      longitude: data.longitude,
      elevation: data.elevation,
      address: data.address,
      city: data.city,
      county: data.county,
      state: data.state,
      zip: data.zip,
      siteLocation: data.siteLocation,
      siteArea: data.siteArea
    }))

    isChanged.current = true

    closeLocate()

  }

  const addLibrary = () => {

    if (!props.user.library > 1) {
      alert('You do not have the required permission. Contact an admin.')    
    } else if (isValidated.description === null || isValidated.description === '') {
        alert("Please provide a description.")
    } else if (isValidated.company === null || isValidated.company === '') {
        alert("Please provide a company.")
    } else if (isValidated.jobDate === null || isValidated.jobDate === '') {
      alert("Please provide a job date.")
    } else if (isValidated.latitude === null || isValidated.latitude === '') {
        alert("Please provide a latitude.")
    } else if (isValidated.longitude === null || isValidated.longitude === '') {
        alert("Please provide a longitude.")
    } else if (isValidated.address === null || isValidated.address === '') {
        alert("Please provide an address.")
    } else if (isValidated.city === null || isValidated.city === '') {
        alert("Please provide a city.")
    } else {

      getLocation(function(latlng){

        fetch('/api/addLibrary', {
          method: 'post',
          headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            by: props.user.username,
            time: formatDateTime(new Date()),
            lat: latlng.lat,
            lng: latlng.lng,
            device: props.user.device,            
            description: replaceStr(isValidated.description),
            company: replaceStr(isValidated.company),
            jobDate: formatDateYMD(isValidated.jobDate),
            address: replaceStr(isValidated.address),
            city: isValidated.city,
            county: isValidated.county,
            state: isValidated.state,
            zip: isValidated.zip,
            latitude: isValidated.latitude,
            longitude: isValidated.longitude,
            elevation: isValidated.elevation,
            siteLocation: isValidated.siteLocation,
            siteArea: isValidated.siteArea,
            filePath: ''
          })
        })
        .then(res=>res.json())
        .then(
          (result) => {
            //console.log('result: ' + JSON.stringify(result))

            addActivity('jobs', props.filter.jobNumber, '', props.component, 'add', '', props.user.username)

            fetchData() // i need the id if edited
            isChanged.current = false
            closeModal()

          },
          (error) => {

            alert('Error: could not add library. Contact and admin.')
            console.log('Error: addLibrary --> ' + error)
          }
        )

      })

    }

  }

  const editLibrary = () => {

    if (!props.user.library > 1) {
      alert('You do not have the required permission. Contact an admin.')    
    } else if (isValidated.description === null || isValidated.description === '') {
        alert("Please provide a description.")
    } else if (isValidated.company === null || isValidated.company === '') {
        alert("Please provide a company.")
    } else if (isValidated.jobDate === null || isValidated.jobDate === '') {
      alert("Please provide a job date.")
    } else if (isValidated.latitude === null || isValidated.latitude === '') {
        alert("Please provide a latitude.")
    } else if (isValidated.longitude === null || isValidated.longitude === '') {
        alert("Please provide a longitude.")
    } else if (isValidated.address === null || isValidated.address === '') {
        alert("Please provide an address.")
    } else if (isValidated.city === null || isValidated.city === '') {
        alert("Please provide a city.")
    } else {

      getLocation(function(latlng){

        fetch('/api/editLibrary', {
          method: 'post',
          headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            by: props.user.username,
            time: formatDateTime(new Date()),
            lat: latlng.lat,
            lng: latlng.lng,
            device: props.user.device,
            id: isValidated.id,
            description: replaceStr(isValidated.description),
            company: replaceStr(isValidated.company),
            jobDate: formatDateYMD(isValidated.jobDate),
            address: replaceStr(isValidated.address),
            city: isValidated.city,
            county: isValidated.county,
            state: isValidated.state,
            zip: isValidated.zip,
            latitude: isValidated.latitude,
            longitude: isValidated.longitude,
            elevation: isValidated.elevation,
            siteLocation: isValidated.siteLocation,
            siteArea: isValidated.siteArea,
            filePath: ''
          })
        })
        .then(res=>res.json())
        .then(
          (result) => {
            //console.log('result: ' + JSON.stringify(result))            

            addActivity('jobs', props.filter.jobNumber, '', props.component, 'edit', '', props.user.username)

            fetchData() // status wont update!&#$* so update all
            isChanged.current = false
            closeModal()

          },
          (error) => {

            alert('Error: could not edit library. Contact and admin.')
            console.log('Error: editLibrary --> ' + error)
          }
        )

      })

    }

  }

  const deleteLibrary = () => {

    if (!props.user.job > 2) {
      alert('You do not have the required permission. Contact an admin.')
    } else {

      if (window.confirm('If you proceed, this will be deleted. Proceed?')) {

        fetch('/api/deleteLibrary', {
          method: 'post',
          headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: isValidated.id
          })
        })
        .then(res=>res.json())
        .then(
          (result) => {
            //console.log('result: ' + JSON.stringify(result))

            addActivity('jobs', props.filter.jobNumber, '', props.component, 'delete', '', props.user.username)

            //fetchData()
            setFetchedData(fetchedData.filter(data => data.id !== isValidated.id))            
            isChanged.current = false
            closeModal()

          },
          (error) => {

            alert('Error: could not delete library. Contact and admin.')
            console.log('Error: deleteLibrary --> ' + error)
          }
        )

      }

    }

  }

  const search = (e) => {
    let value = e.target.value
    setSearchValue(value)
  }

  const clearSearch = () => {
    document.getElementById('searchInput').value = ''
    setSearchValue('')
  }  

  const openAdd = () => setIsModal(prevState => ({...prevState, add: true}))

  const openEdit = () => setIsModal(prevState => ({...prevState, edit: true}))

  const toggleEdit = () => setIsModal(prevState => ({...prevState, editMode: isModal.editMode ? false : true}))

  const toggleEditAddress = () => setIsModal(prevState => ({...prevState, editAddress: isModal.editAddress ? false : true}))

  const toggleGoogle = () => setIsModal(prevState => ({...prevState, google: isModal.google ? false : true}))

  // const openSite = (e) => {

  //   let i = parseInt(e.currentTarget.getAttribute('data-i'))

  //   setIsValidated(prevState => ({...prevState,
  //     latitude: fetchedData[i].latitude,
  //     longitude: fetchedData[i].longitude,
  //     siteLocation: fetchedData[i].sitelocation,
  //     siteArea: fetchedData[i].sitearea
  //   }))

  //   setIsModal(prevState => ({...prevState, site: true}))

  // }

  // const closeSite = () => {
  //   setIsModal(prevState => ({...prevState, site: false}))
  //   clearIsValidated()
  // }

  const openLocate = () => setIsModal(prevState => ({...prevState, locate: true}))

  const closeLocate = () => setIsModal(prevState => ({...prevState, locate: false}))    

  const closeModal = () => {

    if (isChanged.current) {
      if (window.confirm('You have unsaved data. Proceed?')) {
        setIsModal(prevState => ({...prevState, add: false, edit: false}))
        clearIsValidated()
        isChanged.current = false        
      }
    } else {
      setIsModal(prevState => ({...prevState, add: false, edit: false}))
      clearIsValidated()
    }

  }  

  // const createFolders = (who, what) => {

  //   // create folders

  //   let fs = window.require('fs')

  //   let path

  //   let drive = 'T'

  //   if (who == 'job') {

  //     path = `${drive}:/Job Support`

  //     let jn = what

  //     fs.mkdir(path, (err) => {

  //       path = `${drive}:/Job Support/- ${jn.substring(0, 2)}00`

  //       fs.mkdir(path, (err) => {

  //         path = `${drive}:/Job Support/- ${jn.substring(0, 2)}00/${jn}`

  //         fs.mkdir(path, (err) => {

  //           fs.mkdir(path+'/Analysis', err => err ? console.log(`Err: ${err}`) : console.log('create Analysis'))
  //           fs.mkdir(path+'/Lab Data', err => err ? console.log(`Err: ${err}`) : console.log('create Lab'))
  //           fs.mkdir(path+'/Plans', err => err ? console.log(`Err: ${err}`) : console.log('create Plans'))
  //           fs.mkdir(path+'/Plates and Appendices', err => err ? console.log(`Err: ${err}`) : console.log('create Plates'))
  //           fs.mkdir(path+'/Site Photos', err => err ? console.log(`Err: ${err}`) : console.log('create Photos'))

  //         })

  //       })

  //     })

  //   } else if (who === 'prop') {

  //     path = `${drive}:/PN`

  //     let pn = String(what)

  //     fs.mkdir(path, (err) => {

  //       path = `${drive}:/PN/${pn.substring(0, 2)}00`

  //       fs.mkdir(path, err => err ? console.log(`Err: ${err}`) : console.log('created'))

  //     })

  //   }

  // }

  let listOfData = fetchedData.map((data, i) => {    

    let filter = filterData(data, searchValue)
    //console.log(`filter ${JSON.stringify(data)}`)

    if (filter) {

      if (isModal.google) updateMap(data.id, true)

      // im piggy backing selectJob which is used by JobMenu as well, hence the td positions

      return (
        <tr key={data.id.toString()} data-i={i} data-id={data.id} onClick={selectRow} onMouseOver={hightlightMarker}>
          <td style={{display: 'none'}}>{data.latitude}</td>
          <td style={{display: 'none'}}>{data.longitude}</td>
          <td style={{display: 'none'}}>{data.sitelocation}</td>
          <td style={{display: 'none'}}>{data.sitearea}</td>          
          {isModal.google ?
            <td>
              {data.latitude === '' || data.latitude === null || data.longitude === '' || data.longitude === null ? <Icon name='wrong_location' color='tomato' /> : null}
            </td> : null
          }
          <td>{data.id}</td>
          <td style={{width: 100}}>{data.description}</td>          
          <td style={{width: 100}}>{data.company}</td>
          <td>{data.jobDate}</td>
          {isModal.google ? null :
            <>              
              <td style={{maxWidth: 200}}>{data.address}, {data.city}, {data.county}, {data.state} {data.zip}</td>              
            </>
          }
        </tr>
      )

    } else {
      if (isModal.google) updateMap(data.id, false)
    }

  })  

  //const notElectron = () => alert('Please use the desktop version of the Job App to add Jobs and Props. However, you can still edit through the web version.')

  let styleBtn = {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    borderRadius: 10,
    border: '2px solid dodgerblue',
    marginTop: 100
  }

  let modalContent = (
    <div style={{width: '100%', height: '100%', textAlign: 'center'}}>       

      <div style={{display: 'inline-block', textAlign: 'right', margin: 10}}>        

        <div>
          <div><label className='label'>Description</label></div>
          <textarea style={{height: 200}} className='textArea' placeholder='more details means better filtering...' pattern="[a-zA-Z0-9]{1,}" name='description' onInput={validate} onChange={changedData} defaultValue={isValidated.description} required></textarea>
        </div>

        <div>
          <div><label className='label'>Company</label></div>
          <textarea style={{height: 200}} className='textArea' pattern="[a-zA-Z0-9]{1,}" name='company' onInput={validate} onChange={changedData} defaultValue={isValidated.company} required></textarea>
        </div>

        <div>
          <label className='label'>Job Date</label>
          <input className='input' type="date" pattern=".{1,}" name='jobDate' onInput={validate} onChange={changedData} defaultValue={isValidated.jobDate === '' || isValidated.jobDate === null ? null : isValidated.jobDate} required />
        </div>

        <CircleButton iconName='add_location' onClick={openLocate} /><br />

        <div style={{display: 'flex', alignItems: 'center'}}>
          {isValidated.siteLocation !== null && isValidated.siteLocation !== '' ? <Icon name='where_to_vote' outline={true} /> : <Icon name='not_listed_location' color='tomato' outline={true} />}
          <span style={{verticalAlign: 'base-line', color: isValidated.siteLocation !== null && isValidated.siteLocation !== '' ? 'dodgerblue' : 'tomato'}}>Site Location</span>
        </div>

        {isValidated.siteLocation !== null && isValidated.siteLocation !== '' ? <p>Area: {Math.round((isValidated.siteArea) * 10) / 10} acres</p> : null}

        <div style={{display: 'flex', alignItems: 'center'}}>
          {isValidated.latitude !== null && isValidated.latitude !== '' ? <Icon name='where_to_vote' outline={true} /> : <Icon name='not_listed_location' color='tomato' outline={true} />}
          <span style={{verticalAlign: 'base-line', color: isValidated.latitude !== null && isValidated.latitude !== '' ? 'dodgerblue' : 'tomato'}}>Lat/Lng</span>
        </div>

        {isValidated.latitude !== null && isValidated.latitude !== '' ? <p>{isValidated.latitude}, {isValidated.longitude}</p> : null}

        <div style={{display: 'flex', alignItems: 'center'}}>
          {isValidated.address !== null && isValidated.address !== '' ? <Icon name='where_to_vote' outline={true} /> : <Icon name='not_listed_location' color='tomato' outline={true} />}
          <span style={{verticalAlign: 'base-line', color: isValidated.address !== null && isValidated.address !== '' ? 'dodgerblue' : 'tomato'}}>Address</span>
        </div>

        {isModal.editAddress ?
          <>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <Icon name='info' color='orange' outline={true} />
              <span style={{verticalAlign: 'base-line', color: 'orange'}}>Editing the address will NOT update the lat/lng</span>
            </div>

            <div>
              <div><label className='label'>Address</label></div>
              <textarea style={{height: 50}} className='textArea' pattern="[a-zA-Z0-9]{1,}" name='address' onInput={validate} onChange={changedData} defaultValue={isValidated.address} required></textarea>
            </div>

            <div>
              <div><label className='label'>City</label></div>
              <textarea style={{height: 50}} className='textArea' pattern="[a-zA-Z]{1,}" name='city' onInput={validate} onChange={changedData} defaultValue={isValidated.city} required></textarea>
            </div>

          </>: null
        }

        {isValidated.address !== null && isValidated.address !== '' ?
          <>
            <div style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}} onClick={toggleEditAddress}>
              <span style={{verticalAlign: 'base-line', marginRight: 10}}>
                <p>{isValidated.address}</p>
                <p>{isValidated.city}, {isValidated.county}, {isValidated.state} {isValidated.zip}</p>
              </span>
              <Icon name='edit' title='edit' color={isModal.editAddress ? 'dodgerblue' : 'gray'} />
            </div>

          </> : null
        }

        <div>
          <label className='label'>Elevation (ft)</label>
          <input style={{width: 75}} className='input' type="text" pattern="\d{1,}(\.\d{1})?" name='elevation' onInput={validate} onChange={changedData} defaultValue={isValidated.elevation} required />
        </div>

      </div>   

    </div>
  )

  //{isModal.site ? <SiteLocation close={closeSite} latlng={isValidated} /> : null}

  return (
    <>
      {isModal.add || isModal.edit ?
        <Modal
          close={closeModal}
          add={isModal.add ? addLibrary : isModal.edit ? editLibrary : null}
          delete={isModal.edit ? deleteLibrary : null}
          content={modalContent}
          isValidated={isValidated}
        /> : null
      }
      
      {isModal.locate ? <Locate close={closeLocate} add={selectLocate} filter={props.filter} latlng={isValidated} /> : null}      

      <div style={{display: 'flex', width: '100%', height: '100%', overflow: 'auto'}}>

        <div style={{flex: isModal.google ? '0 1 auto' : '1 0 auto', maxWidth: '100%'}}>

          <div style={{display: 'flex', flexFlow: 'column', width: '100%', height: '100%'}}>

            <div style={{width: '100%'}}>

              {props.user.job > 1 ? <Icon name='add_circle' title='add' onClick={openAdd} /> : null}
              <Icon name='refresh' title='refresh' onClick={fetchData} />
              <Icon name='location_on' title='View in Google Maps' color={isModal.google ? 'dodgerblue' : 'gray'} onClick={toggleGoogle} />
              <Icon name='download' title='Download to Excel' onClick={exportToExcel} />

            </div>

            <SearchBar search={search} clearSearch={clearSearch} />

            {fetchedData.length > 0 ?

              <div style={{flex: '1', overflow: 'auto'}}>

                <table id="toExcel">

                  <thead>
                    <tr>
                      <th style={{display: 'none'}}>lat</th>
                      <th style={{display: 'none'}}>lng</th>                      
                      <th style={{display: 'none'}}>id</th>
                      {isModal.google ? <th></th> : null}
                      <th>ID</th>                      
                      <th>Descrip</th>
                      <th>Company</th>
                      <th>Date</th>
                      {isModal.google ? null : <th>Address</th>}
                    </tr>
                  </thead>

                  <tbody>
                    {listOfData}
                  </tbody>

                </table>

              </div> : <p style={{margin: 10}}>{isLoading ? `Loading...` : `No Library found.`}</p>

            }

          </div>

        </div>

        {isModal.google ?

          <div style={{margin: 10, flex: '1 0 auto', overflow: 'auto'}}>
            <div style={{height: '100%', width: '100%'}} ref={googleRef}></div>
          </div> : null

        }

      </div>

    </>
  )

}

export default Library
